import { render, staticRenderFns } from "./DelaisNews.vue?vue&type=template&id=526324b7&"
import script from "./DelaisNews.vue?vue&type=script&lang=js&"
export * from "./DelaisNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports